import {FETCH_TG_CLIENTS} from "./types";

const initialState = {
    allTgClients: []
}

export const telegramClientsReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_TG_CLIENTS:
            return {...state, allTgClients: action.payload}
        default: return state
    }
}